import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.187 3.097a.267.267 0 01.254.17l1.31 3.403a.26.26 0 01.016.062l-.06.209-4.064 5.93a.267.267 0 01-.369.07l-4.96-3.343a.267.267 0 01-.071-.372L7.32 3.275a.267.267 0 01.215-.116l3.652-.062zm.8 6.31l-1.964 2.866.736.294a.267.267 0 00.355-.173l.872-2.987zM9.56 12.95l-.257.374c-.33.484-.99.61-1.476.282l-4.96-3.343a1.067 1.067 0 01-.284-1.488L6.66 2.823c.195-.285.516-.458.862-.464l3.652-.062c.447-.008.852.265 1.013.683l1.31 3.402c.113.29.092.614-.053.885l-1.562 5.351a1.067 1.067 0 01-1.42.692l-.902-.361z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.571 6.172a.333.333 0 10-.372.553.333.333 0 00.372-.553zm-1.126-.357a1.133 1.133 0 111.88 1.267 1.133 1.133 0 01-1.88-1.267zM8.426 9.8a.333.333 0 10-.373.552.333.333 0 00.373-.553zM7.3 9.441a1.133 1.133 0 111.88 1.267A1.133 1.133 0 017.3 9.442zM10.713 7.46a.4.4 0 01-.273.495l-5 1.454a.4.4 0 11-.223-.768l5-1.454a.4.4 0 01.496.272z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;